import { ref, onMounted } from 'vue';
import http from '@/http.js';
import { useStore } from 'vuex';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useLancement = (props, { emit }) => {
        const store = useStore();
        const saisieMap = ref({});
        const idBdd = ref('');
        const bdds = ref([]);

        const toastMessage = ref('');
        const showNotification = ref(false);
        const toastType = ref('info');
        const duration = ref(5000);

        const initializeSaisieParams = () => {
            saisieMap.value = props.parametres.reduce((acc, param) => {
                acc[param.idParametre] = '';
                return acc;
            }, {});
        };

        const fetchBdd = async () => {
            try {
                const data = await http.getBddByIdJeuRequetes(props.idjeu);
                bdds.value = data;
            } catch (error) {
                console.error("Erreur lors de la récupération des bases de données :", error);
            }
        };

        const lancerJeu = async () => {
            const lancement = {
                idjeuRequetes: props.jeuRequete.idJeuRequetes,
                idUser: store.state.idUtilisateur,
                saisie: Object.keys(saisieMap.value).map(id => ({
                    idParametre: id,
                    saisie: saisieMap.value[id],
                })),
                params: props.parametres,
                idBdd: idBdd.value,
            };

            try {
                await http.lancerJeu(lancement);
                emit('close');
                window.scrollTo(0, 0);
                emit('notification', {
                    showNotification: true,
                    toastMessage: "Le Rapport est en cours de constitution. Vous recevrez un mail quand il sera prêt.",
                    toastType: "success",
                });
            } catch (error) {
                console.error("Erreur lors du lancement du jeu :", error);
                emit('notification', {
                    showNotification: true,
                    toastMessage: "Erreur lors du lancement du jeu.",
                    toastType: "danger",
                });
            }
        };

        onMounted(() => {
            initializeSaisieParams();
            fetchBdd();
        });

        return {
            saisieMap,
            idBdd,
            bdds,
            lancerJeu,
            toastMessage,
            showNotification,
            toastType,
            duration,
        };
};